import { render, staticRenderFns } from "./MdtWizardSimple.vue?vue&type=template&id=6a4f7119&scoped=true"
import script from "./MdtWizardSimple.vue?vue&type=script&lang=js"
export * from "./MdtWizardSimple.vue?vue&type=script&lang=js"
import style0 from "./MdtWizardSimple.vue?vue&type=style&index=0&id=6a4f7119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f7119",
  null
  
)

export default component.exports